//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        variants: {
            type: [Array],
            default: []
        },
        type: {
            type: [String],
            default: 'overview'
        },
        selling_unit: {
            type: [String],
            default: ''
        },
        in_unit: {
            type: [String, Number],
            default: ''
        },
        smallest_unit: {
            type: [String],
            default: ''
        },
        model: {
            type: [String],
            default: ''
        },
        packageSize: {
            type: [String],
            default: ''
        },
        mainProduct: {
            type: [Number],
            default: 0
        },
        free: {
            type: [String, Number],
            default: 0
        },
        request: {
            type: [String, Number],
            default: 0
        },
        discount: {
            type: [String, Number],
            default: 0
        },
        max_order: {
            type: [String, Number],
            default: 0
        },
        always_buyable: {
            type: [Boolean],
            default: false
        }
    },

    data: function data() {
        return {
            added: false,
            pid: this.variants[0].pid,
            qty: this.in_unit ? this.in_unit : 1,
            loading: false
        };
    },


    methods: {
        submit: function submit() {
            var _this = this;

            if (this.qty % this.in_unit !== 0) {
                swal({
                    html: true,
                    title: '',
                    text: 'Die eingegebene Menge entspricht nicht der Verpackungsmenge. Diese muss durch die Verpackungsmenge teilbar sein.',
                    type: "error"
                });
            } else {

                this.loading = true;

                new Form({
                    pid: this.pid,
                    qty: this.qty,
                    pstock: this.pstock
                }).post('/api/cart/add').then(function (response) {
                    if (response.success) {
                        App.event.fire('cart.item.inserted', response.item);
                        App.event.fire('cart.updated', response.data);
                    } else {
                        swal({
                            html: true,
                            title: '',
                            text: response.error_text,
                            type: "error"
                        });
                    }

                    _this.added = true;
                    _this.loading = false;
                    setTimeout(function () {
                        _this.added = false;
                    }, 2000);
                }).catch(function (errors) {
                    _this.loading = false;
                });
            }
        }
    },

    computed: {
        variant: function variant() {
            var _this2 = this;

            return this.variants.filter(function (item) {
                return item.pid == _this2.pid ? true : false;
            }).pop();
        },
        pstock: function pstock() {
            return this.variant.pstock;
        },
        show: function show() {
            return true; //App.user.active;
        },
        availability: function availability() {
            var stock = parseInt(this.variant.pstock);
            return stock > 0 ? stock + ' ' + this.selling_unit : 'Derzeit nicht auf Lager.';
        },
        orderQty: function orderQty() {
            if (this.in_unit < 2) {
                return '1 ' + this.selling_unit;
            } else {
                return '1 Packung = ' + this.in_unit + ' ' + this.smallest_unit;
            }
        }
    },

    filters: {
        money: function money(value) {
            return parseInt(value);
        },
        discountmoney: function discountmoney(value, discount) {
            var price = parseFloat(value) * ((100 - discount) / 100);
            return parseInt(price);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/add-to-cart/components/AddToCart.vue
// module id = sO2J
// module chunks = 4